import { render } from "./Fullstack.vue?vue&type=template&id=fd25840c&scoped=true"
import script from "./Fullstack.vue?vue&type=script&lang=js"
export * from "./Fullstack.vue?vue&type=script&lang=js"

import "./Fullstack.vue?vue&type=style&index=0&id=fd25840c&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Tenisu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd25840c"]])

export default __exports__